<div class="card card-borderless bg-transparent">
  <!--begin::Body-->
  <div class="card-body bg-light bg-light-{{ colorSet }} rounded-3 py-2 px-2">
    <!--begin::Row-->
    <div class="row align-items-center">
      <!--begin::Col-->
      <div class="col-sm-7 mb-5 mb-sm-0 text-center text-sm-start">
        <!--begin::Wrapper-->
        <div class="d-flex justify-content-between h-100 flex-column pt-7 pb-7 ps-7">
          <!--begin::Container-->
          <div>
            <!--begin::Title-->
            <div class="mb-4">
              <h3
                *ngIf="
                  _message?.main?.value?.length || !!_message?.main?.writing
                "
                class="fs-2 text-gray-800"
              >
                {{ _message.main.value
                }}<app-ai-cursor
                  *ngIf="!!_message?.main?.writing"
                ></app-ai-cursor>
              </h3>
              <span
                *ngIf="_message?.sub?.value?.length || !!_message?.sub?.writing"
                class="fs-6 opacity-75"
                ><span [innerHTML]="_message.sub.value"></span><app-ai-cursor
                  *ngIf="!!_message?.sub?.writing"
                ></app-ai-cursor
              ></span>
            </div>
            <!--end::Title-->

            <!--begin::Items-->
            <div
              *ngIf="!!features?.length"
              class="d-flex align-items-center flex-wrap d-grid gap-2"
            >
              <!--begin::Item-->
              <div class="d-flex align-items-center me-5 me-xl-13">
                <!--begin::Symbol-->
                <div class="symbol symbol-30px symbol-circle me-3">
                  <span
                    class="symbol-label"
                    style="background: rgb(0 0 0 / 15%)"
                  >
                    <i class="ler-duotone ler-abstract-41 fs-4"
                      ><span class="path1"></span><span class="path2"></span
                    ></i>
                  </span>
                </div>
                <!--end::Symbol-->

                <!--begin::Info-->
                <div class="m-0">
                  <span class="text-opacity-75 text-gray-600 fs-8"
                    >Projects</span
                  >
                  <span class="fw-bold fs-7 d-block">Up to 500</span>
                </div>
                <!--end::Info-->
              </div>
              <!--end::Item-->

              <!--begin::Item-->
              <div class="d-flex align-items-center">
                <!--begin::Symbol-->
                <div class="symbol symbol-30px symbol-circle me-3">
                  <span
                    class="symbol-label"
                    style="background: rgb(0 0 0 / 15%)"
                  >
                    <i class="ler-duotone ler-abstract-26 fs-4"
                      ><span class="path1"></span><span class="path2"></span
                    ></i>
                  </span>
                </div>
                <!--end::Symbol-->

                <!--begin::Info-->
                <div class="m-0">
                  <span class="text-opacity-75 text-gray-600 fs-8">Tasks</span>
                  <span class="fw-bold fs-7 d-block">Unlimited</span>
                </div>
                <!--end::Info-->
              </div>
              <!--end::Item-->
            </div>
            <!--end::Items-->
          </div>
          <!--end::Container-->

          <!--begin::Action-->
          <div class="m-0 d-flex flex-column">
            <app-dynamic-ai-button
            *ngIf="!hideMainAction"
              (buttonClick)="CTAClick.emit()"
              [routerLink]="routeToGo"
              [buttonLabel]="buttonLabel"
              [iconSvg]=""
              [buttonSettings]="{ colorSet: colorSet }"
            ></app-dynamic-ai-button>
            <ng-content *ngIf="hideMainAction" select="[mainAction]"></ng-content>
            <ng-content select="[extraAction]"></ng-content>
          </div>
          <!--begin::Action-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--begin::Col-->

      <!--begin::Col-->
      <div class="col-sm-5 text-center align-self-end mb-n15">
        <!--begin::Illustration-->
        <img [src]="_image" class="h-175px h-lg-200px float-image" alt="" />
        <!--end::Illustration-->
      </div>
      <!--begin::Col-->
    </div>
    <!--begin::Row-->
  </div>
  <!--end::Body-->
</div>
